import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";

function AddAdultStay({ adultId, campuses = [], addStay }) {
    const [open, setOpen] = useState(false);
    const [stay, setStay] = useState({
        residentialBase: "",
        arrivalDate: new Date(), // Date object for MUI DatePicker
        departureDate: new Date(),
        notes: "",
        overnightResident: false,
        gender: "",
    });

    const handleClickOpen = () => {
        // Default to the current season's camp window — never a hardcoded
        // year (that's how stays were silently landing in 2025).
        const year = new Date().getFullYear();
        setStay((prevStay) => ({
            ...prevStay,
            arrivalDate: new Date(year, 5, 28), // 28 Jun
            departureDate: new Date(year, 7, 10), // 10 Aug
        }));
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = () => {
        const payload = {
            residentialBase: stay.residentialBase,
            arrivaldate: stay.arrivalDate.toISOString().slice(0, 10),
            departuredate: stay.departureDate.toISOString().slice(0, 10),
            notes: stay.notes,
            overnightResident: stay.overnightResident,
            gender: stay.overnightResident ? stay.gender : null, // <-- Only include if overnight
        };

        addStay(payload, adultId);
        handleClose();
    };

    const handleDateChange = (date, name) => {
        setStay((prevStay) => ({
            ...prevStay,
            [name]: date,
        }));
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setStay((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    return (
        <div>
            <Button
                startIcon={<AddCircleOutlineIcon />}
                variant="outlined"
                size="small"
                onClick={handleClickOpen}
            >
                Add stay
            </Button>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Add Stay</DialogTitle>
                <DialogContent>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Stack spacing={2} mt={1}>
                            <FormControl>
                                <InputLabel id="campus-label">
                                    Campus
                                </InputLabel>
                                <Select
                                    labelId="campus-label"
                                    id="campus"
                                    name="residentialBase"
                                    value={stay.residentialBase}
                                    onChange={handleChange}
                                    label="Campus"
                                >
                                    {campuses.map((campus) => (
                                        <MenuItem
                                            key={campus.id}
                                            value={campus.name}
                                        >
                                            {campus.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <DatePicker
                                label="Arrive"
                                value={stay.arrivalDate}
                                onChange={(date) =>
                                    handleDateChange(date, "arrivalDate")
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        sx={{ mb: 0, mt: 0 }}
                                    />
                                )}
                            />
                            <DatePicker
                                label="Depart"
                                value={stay.departureDate}
                                onChange={(date) =>
                                    handleDateChange(date, "departureDate")
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        sx={{ mb: 0, mt: 0 }}
                                    />
                                )}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={stay.overnightResident}
                                        onChange={(event) =>
                                            setStay((prevStay) => ({
                                                ...prevStay,
                                                overnightResident:
                                                    event.target.checked,
                                            }))
                                        }
                                        name="overnightResident"
                                        color="primary"
                                    />
                                }
                                label="Overnight Resident?"
                            />
                            <FormControl
                                fullWidth
                                disabled={!stay.overnightResident}
                            >
                                <InputLabel id="gender-label">
                                    Gender
                                </InputLabel>
                                <Select
                                    labelId="gender-label"
                                    id="gender"
                                    name="gender"
                                    value={stay.gender}
                                    onChange={handleChange}
                                >
                                    <MenuItem value="Male">Male</MenuItem>
                                    <MenuItem value="Female">Female</MenuItem>
                                    <MenuItem value="Other">Other</MenuItem>
                                </Select>
                                <FormHelperText>
                                    This is only used for room allocation during
                                    overnight stays.
                                </FormHelperText>
                            </FormControl>

                            <TextField
                                label="notes"
                                name="notes"
                                variant="standard"
                                value={stay.notes}
                                onChange={handleChange}
                            />
                        </Stack>
                    </LocalizationProvider>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleSave}>Save</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default AddAdultStay;
